import React, { useEffect, useMemo } from 'react';
import { useForm } from 'react-hook-form';
import { setFormPage } from '../../../reactive/actions';
import { FORM_RADIO_COMPONENT_TYPES, FORM_RADIO_TYPES } from '../../../components/FormRadio/types';
import { vars } from '../../../reactive';
import { useLocation } from '@reach/router';
import useUserProfile from '../../../hooks/useUserProfile';
import { clearLocalStorage, kebabCase } from '../../../utils';
import { useQuery, useReactiveVar } from '@apollo/client';
import { FORM_PAGES } from '../../../components/Form/types';
import { AnalyticsEvents, trackEvent } from '../../../utils/analytics';
import { FormItemContainer, FormLabel, MainTitle, PriceTitleContainer } from '../../../components/FormRadio/styled';
import FormRadioFroms from '../../../components/FormRadio/Forms/FormRadio';
import { GetReducedBranchForms } from '../../../utils/queries';
import { BranchForm } from '../../../types';

const FormFillSelect = () => {
  const [getProfile, { loading: userProfileLoading }] = useUserProfile(true);
  const currentBranch = useReactiveVar(vars.currentBranch);
  const type = FORM_RADIO_TYPES.FORMS;
  const { title } = FORM_RADIO_COMPONENT_TYPES[type];
  const { data: { getForms: forms } = {} } = useQuery<{ getForms: BranchForm[] }>(GetReducedBranchForms, {
    variables: {
      branchId: currentBranch?.id
    },
    fetchPolicy: 'network-only'
  });

  const { register, handleSubmit, reset, formState } = useForm();
  const location = useLocation();
  const selectedFormQueryParam = useMemo(() => new URLSearchParams(location.search).get('form'), [location.search]);

  const isLoggedIn = useReactiveVar(vars.isLoggedIn);

  const kebabCaseForms = forms?.map(form => ({
    ...form,
    id: form!.id,
    name: kebabCase(form!.name.trimEnd().trimStart())
  }));

  const preselectedForm = kebabCaseForms?.find(form => form.name.toLowerCase() === selectedFormQueryParam?.toLowerCase());

  const checkIfAvailable = (formId: string) => {
    return true;
  };

  const onSubmit = (data: Record<string, string[]>) => {
    const selectedForms = forms?.filter(form => data?.forms?.includes(form.id));
    clearLocalStorage();

    vars.currentBranch(currentBranch);
    vars.selectedForms(selectedForms);
    selectedForms?.forEach(form => {
      trackEvent(AnalyticsEvents.FORM_SELECTED, {
        name: form?.name
      });
    });

    if (vars.isLoggedIn()) {
      getProfile();
    } else {
      setFormPage(FORM_PAGES.CREATE_ACCOUNT_EMAIL);
    }
  };

  useEffect(() => {
    if (preselectedForm?.id) {
      onSubmit({ forms: [preselectedForm.id] });
    }
  }, [preselectedForm?.id]);

  return (
    <FormRadioFroms
      type={FORM_RADIO_TYPES.FORMS}
      formOptions={{ register, handleSubmit, reset, formState }}
      checkIfAvailable={checkIfAvailable}
      dataArr={forms}
      borderColor={currentBranch?.colors?.secondary}
      onSubmit={onSubmit}
      loading={userProfileLoading}
      defaultCheckedId={preselectedForm?.id}
      isLoggedIn={isLoggedIn}
      noNextButton={!forms?.length}
      title={forms?.length ? title : 'No forms available for this provider.'}
    />
  );
};

export default FormFillSelect;
